const DriShareTypeEnum = Object.freeze({
    PRIMARY: 'PRIMARY', // DRIS
    SECONDARY: 'SECONDARY' // DRIP
});

export default DriShareTypeEnum;
